module.exports = __webpack_public_path__ + "img/chick-mygallinas-icon.907482d7.svg";